export function dataInRequest(params = {}) {
  return {
    type: '@cercasVirtuais/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@cercasVirtuais/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@cercasVirtuais/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@cercasVirtuais/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@cercasVirtuais/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@cercasVirtuais/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@cercasVirtuais/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@cercasVirtuais/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@cercasVirtuais/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@cercasVirtuais/RECORD_FILTERING',
    payload: { params },
  };
}

export function resetFind() {
  return {
    type: '@cercasVirtuais/RESET_FIND',
  };
}
